import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { OrderingOption } from 'generated/graphql-types';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { accountsRoute } from 'src/app/app-routing.module';
import { searchDebounce } from '../../utils/search-debounce-rxjs';
import { RegisterOptions } from '../models/register-options';
import { RegisterView } from '../models/register-view';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-register-view',
    styleUrls: ['./register-view.component.scss'],
    templateUrl: './register-view.component.html',
    standalone: false
})
export class RegisterViewComponent<TRegisterOptions extends RegisterOptions, TOrderingOptions extends OrderingOption>
   extends RegisterView<TRegisterOptions, TOrderingOptions>
   implements OnInit, OnDestroy
{
   @Input()
   hasSearchInput = true;

   @Input() moreActionsMenu!: MatMenu;

   @Input() searchText: string | null;

   private destroyed$ = new Subject<void>();

   private searchTextChange = new Subject<string>();

   accountsRoute = accountsRoute;

   ngOnInit(): void {
      this.searchTextChange.pipe(searchDebounce(), distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe(() => {
         this.emitQuickFilterChange();
      });
      this.pluralName = this.name + 's';
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onSearchTextChange(searchText: string): void {
      this.searchText = searchText.replace(/\\/g, '');
      this.searchTextChange.next(searchText);
   }

   private emitQuickFilterChange(): void {
      this.registerOptions = { ...this.registerOptions, searchText: this.searchText };
      this.quickFilterChange.emit(this.registerOptions);
   }
}
